import React from 'react'
import appTheme from '../appTheme'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@mui/material/styles'
import ErrorIcon from '@mui/icons-material/Report';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import { Grid, Box, Typography, Button, Stack, Dialog, DialogContent} from "@mui/material";

const ConfirmDialog = (props) => {
    const {
      severity,
      onClose,
      message,
      okText,
      cancelText,
      // ⬆ filtering out props that `dialog` doesn’t know what to do with.
      ...rest
    } = props

    //console.log("Call ConfirmDialog - Message: ", message);
    let localMessage = message;

    const okClicked = () => {
      localMessage = "";
      onClose(true);
    }
    const cancelClicked = () => {
      localMessage = "";
      onClose(false);
    }

    function NewLineMessage(props) {
      return props.text.split('\\n').map((line, index) => <Box key={index} component='span'>{line}<br/></Box>)
    }
  
    return (
      <ThemeProvider theme={appTheme}>
      <Dialog
        {...rest} // `children` is just another prop!
        open={(localMessage.length > 0)}
        onClose={cancelClicked}
      >
        <DialogContent>
          <Grid container direction="row" alignItems="flex-start" justifyContent="flex-start" spacing={1} columns={10}>
            <Grid item id="ConfirmIcon" xs={2}>
            {( !severity || severity === "info") && <InfoIcon fontSize="large" color='success'/>}
            {( severity === "warning") && <WarningIcon fontSize="large" color='secondary' />}
            {( severity === "error") && <ErrorIcon fontSize="large" color='error'/>}
            </Grid>
            <Grid item id="ConfirmMessage" xs={8}>
              <Typography
                style={{ whiteSpace: 'pre-line'}}
                sx={{
                  fontSize: '18px',
                  fontWeight: '500',
                  fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
                  color: 'common.black',
                }}>
              <NewLineMessage text={localMessage} />
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="column" sx={{marginTop: '12px'}} spacing={1} columns={12} alignItems={(okText && cancelText)? 'stretch': 'flex-end'} >
            {okText && <Grid item xs={10} >
              <Button variant='outlined' fullWidth style={{textTransform: 'none'}} sx={{ fontWeight: '500'}} color="confirmBlue" onClick={okClicked}>{okText}</Button>
            </Grid>}
            {cancelText && <Grid item xs={10} >
              <Button variant='outlined' fullWidth style={{textTransform: 'none'}} sx={{ fontWeight: '500'}} color="confirmOrange" onClick={cancelClicked}>{cancelText}</Button>
            </Grid>}  
          </Grid>
        </DialogContent>
      </Dialog>
      </ThemeProvider>
    )
}

ConfirmDialog.muiName = 'Dialog';
ConfirmDialog.propTypes = {
  children: PropTypes.node
};

export default ConfirmDialog
